<!-- Submenu item -->
<li class="nav-item" class="{{ item.class }}">
  <a
    class="nav-link py-1 d-block {{ item.class_a }}"
    href
    (click)="onClick(); (false)"
    [class.new-marker]="item.badge | async"
    *ngIf="!item.disabled || !(item.disabled | async); else disabled"
  >
    <i class="{{ item.icon }}"></i>
    {{ item.name | translate }}
  </a>
  <!-- ACL disabled link -->
  <ng-template #disabled>
    <a
      class="nav-link py-1 d-block {{ item.class_a }}"
      href
      [class.new-marker]="item.badge | async"
      (click)="(false)"
    >
      <i class="fe fe-lock"></i>
      <span class="line-through">{{ item.name | translate }}</span>
    </a>
  </ng-template>

  <!-- Submenu submenu item -->
  <ul
    class="nav collapse show mb-3"
    *ngIf="(item.items | async)?.length && item.expanded"
  >
    <ng-container *ngFor="let subItem of item.items | async">
      <li
        class="nav-item"
        *ngIf="!subItem.visible || (subItem.visible | async)"
      >
        <a href class="nav-link pb-0"
          (click)="onClick(subItem); (false)"
          *ngIf="!subItem.disabled || !(subItem.disabled | async); else subitemDisabled">
          <i class="{{ item.icon }}"></i>
          {{ subItem.name | translate }}
        </a>
        <!-- ACL disabled link -->
        <ng-template #subitemDisabled>
          <a href class="nav-link pb-0"
            (click)="(false)"
          >
            <i class="fe fe-lock"></i>
            <span class="line-through">{{ subItem.name | translate }}</span>
          </a>
        </ng-template>
      </li>
    </ng-container>
  </ul>
</li>
